import React, { useState } from 'react';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideItems, slides } from '../data/content';
const ARROW_CLASS = 'absolute top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-orange-500 text-slate-950 shadow-xl shadow-orange-500/40 ring-4 ring-orange-500/15 transition-[transform,background-color] duration-150 ease-out hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-orange-500 sm:h-14 sm:w-14';
export function LookInside() {
  const [index, setIndex] = useState(0);
  const slide = slides[index];
  const hasMultiple = slides.length > 1;
  const go = (direction: number) => {
    setIndex(current => (current + direction + slides.length) % slides.length);
  };
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-104" data-mp="18yve62kb6sw7">
      <div className="mx-auto max-w-[1000px] text-center" data-id="element-105" data-mp="1dwequy1cyxm1">
        <h2 className="text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2rem]" data-id="element-106" data-mp="a2o42pk0lzgc">
          See What’s Actually Inside{' '}
          <span className="text-orange-500" data-id="element-107" data-mp="60jb7t1e56ur">HEALTH READY™</span>
        </h2>
        <p className="mt-4 text-[1rem] leading-relaxed text-white/90" data-id="element-108" data-mp="jzsux2ot2j3h">
          <strong className="font-bold text-white" data-id="element-109" data-mp="f20s3dmmhcki">Not theory.</strong>{' '}
          Resources designed for the classroom.
        </p>

        <div className="relative mx-auto mt-8 max-w-[620px]" data-id="element-110" data-mp="3nicdtellgclm">
          <figure data-id="element-111" data-mp="3iir9sprkhe21">
            <img key={slide.image} src={slide.image} alt={slide.title} className="mx-auto w-full rounded-lg bg-white" width={804} height={1000} data-id="element-112" data-mp="3ij98dt1pc4d4" />
            <figcaption className="mt-4 text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-orange-500 sm:text-[1.15rem]" data-id="element-113" data-mp="3sekl65tjv1i8">
              {slide.caption}
            </figcaption>
          </figure>

          {hasMultiple && <>
              <button type="button" onClick={() => go(-1)} aria-label="Previous page" className={`${ARROW_CLASS} -left-2 hover:-translate-x-0.5 sm:-left-7`} data-id="element-114" data-mp="13nshpzj8j2x6">
                <ChevronLeftIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-115" data-mp="1dgrfa6wpm3sx" />
              </button>
              <button type="button" onClick={() => go(1)} aria-label="Next page" className={`${ARROW_CLASS} -right-2 hover:translate-x-0.5 sm:-right-7`} data-id="element-116" data-mp="1hi307z4n20us">
                <ChevronRightIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-117" data-mp="tqea8pfahoh0" />
              </button>
            </>}
        </div>

        <div className={`mt-4 items-center justify-center gap-2 ${hasMultiple ? 'flex' : 'hidden'}`} data-id="element-118" data-mp="ynnxpzj4bq27">
          {slides.map((item, itemIndex) => <button key={item.image} type="button" onClick={() => setIndex(itemIndex)} aria-label={`Show ${item.title}`} aria-current={itemIndex === index} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 ${itemIndex === index ? 'w-6 bg-orange-500' : 'w-2 bg-white/30'}`} data-id="element-119" data-mp="2a44go2tvsott" data-mpi={itemIndex} />)}
        </div>

        <ul className="mx-auto mt-8 flex max-w-[720px] flex-wrap justify-center gap-x-5 gap-y-2.5" data-id="element-120" data-mp="1wjjgonw77sib">
          {insideItems.map(item => <li key={item} className="flex items-center gap-1.5 text-[0.95rem] text-white" data-id="element-121" data-mp="1rkyi0swlhgvz">
              <CheckIcon className="h-4 w-4 shrink-0 text-orange-500" strokeWidth={3} aria-hidden="true" data-id="element-122" data-mp="1nky2t61o91nv" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-[620px] text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-orange-500 sm:text-[1.15rem]" data-id="element-123" data-mp="3ozb16sl0ms50">
          Less preparing. More teaching.
        </p>
      </div>
    </section>;
}